import React, { type ReactNode } from 'react';
import Card from '../Card';
import DataContainer from '../../atoms/DataContainer';
import DataSheet from '../../atoms/DataSheet';
import DataHead from '../../atoms/DataHead';
import DataBody from '../../atoms/DataBody';
import DataRow from '../../atoms/DataRow';
import DataCell from '../../atoms/DataCell';
import type { SxProps, Theme } from '@mui/material';

export interface SimpleTableColumn {
  label: string;
  width?: string;
  align?: 'left' | 'right' | 'center';
}

interface SimpleTableProps {
  columns: SimpleTableColumn[];
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export default function SimpleTable({
  columns,
  children,
  sx,
}: SimpleTableProps) {
  return (
    <Card sx={{ mb: 3, p: 0, ...sx }}>
      <DataContainer>
        <DataSheet size="small">
          <DataHead>
            <DataRow sx={{ backgroundColor: '#f5f5f5' }}>
              {columns.map((col, i) => (
                <DataCell
                  key={i}
                  align={col.align}
                  sx={{ width: col.width, fontWeight: 'bold' }}
                >
                  {col.label}
                </DataCell>
              ))}
            </DataRow>
          </DataHead>
          <DataBody>{children}</DataBody>
        </DataSheet>
      </DataContainer>
    </Card>
  );
}
